import React, {Component} from 'react';
import Header from '../components/Header';

export default class About extends Component {
    render() {
        return (
            <div>
                <Header title="Om Fristberegneren"/>
                <div className="container about">
                    <p>Fristberegneren er et enkelt verktøy som raskt kan hjelpe deg å beregne minimumsfrister i anbudskonkurranser.</p>
                    <p>Beregning av minimumsfrister er i stor grad en ren matematisk øvelse, og egner seg derfor til å bli utregnet ved bruk av &quot;formel&quot;. Det vil likevel kunne oppstå tvil om hvordan en frist konkret skal beregnes, f.eks. om betingelsene for forkortelse av fristen er oppfylt. Det er også viktig å være oppmerksom på at Fristberegneren kun beregner minimumsfrister, og at det etter omstendighetene kan være påkrevd med lenger frist, f.eks. fordi det er snakk om et komplekst anbud.</p>
                    <p>Fastsettelse av en for kort frist kan ha alvorlige anbudsrettslige konsekvenser, og du bør derfor alltid vurdere å søke rådgivning hvis du er i tvil om hvor lang en bestemt frist skal eller bør være.</p>
                    <p>Har du spørsmål eller kommentarer til bruken av Fristberegneren, inkludert forslag til forbedringer, tilføyelser av nye funksjoner eller lignende, er du velkommen til å <a href="mailto:fristberegneren@kvale.no">kontakte</a> oss.</p>
                </div>
            </div>

        );
    }
}


// WEBPACK FOOTER //
// ./src/views/About.js